import { FanMark, Wordmark } from "./FanMark";

/**
 * Shared top bar: the fan mark + JAPAN UN·FOLDED wordmark on the left,
 * optional action content on the right. The global ThemeToggle (App.js) floats
 * over the top-right corner, so `right` content is padded clear of it.
 */
export default function BrandHeader({ left, right, border = true }) {
  return (
    <div
      className="flex items-center justify-between px-5 md:px-12 flex-shrink-0"
      style={{ height: 56, borderBottom: border ? "1px solid var(--zen-border)" : "none" }}
    >
      <div className="flex items-center gap-4 min-w-0">
        <div className="flex items-center gap-2.5">
          <FanMark size={20} />
          <Wordmark size={12} />
        </div>
        {left}
      </div>
      <div className="flex items-center gap-4" style={{ paddingRight: 48 }}>
        {right}
      </div>
    </div>
  );
}
